import React from "react";
import { BetOffer, BettingOffer } from "@models";
import { EventType } from "@gp/models";
import classNames from "classnames";

export function EventOfferBettingType(props: {
	offer: BettingOffer | BetOffer;
	withCoefficient?: boolean;
	isPopup?: boolean;
	isPage?: boolean;
	isQuickBetPage?: boolean;
}) {
	const { offer } = props;

	const itemClasses = classNames("card--qp__item", {
		"card--qp--nowrap__item": !props.isPopup,
		"card--mpt__item": !props.isQuickBetPage,
		"card--mpt--nowrap__item": !props.isQuickBetPage && !props.isPopup,
		"slip--quick__item": props.isQuickBetPage,
		"card--qb--nowrap__item": props.isQuickBetPage && !props.isPopup,
	});

	const marketClasses = classNames("card--qp__market", {
		"card--qp--nowrap__market": !props.isPopup,
		"card--mpt__market": !props.isQuickBetPage,
		"card--mpt--nowrap__market": !props.isQuickBetPage && !props.isPopup,
		"slip--quick__market": props.isQuickBetPage,
		"card--qb--nowrap__market": props.isQuickBetPage && !props.isPopup,
	});

	const typeClasses = classNames("card--qp__type", {
		"card--qp--nowrap__type": !props.isPopup,
		"card--mpt__type": !props.isQuickBetPage,
		"card--mpt--nowrap__type": !props.isQuickBetPage && !props.isPopup,
		slip__pick__name: props.isQuickBetPage,
		"card--qb--nowrap__type": props.isQuickBetPage && !props.isPopup,
	});

	const tipClasses = classNames("card--qp__tip", {
		"card--qp--nowrap__tip": !props.isPopup,
		"card--mpt__tip": !props.isQuickBetPage,
		"card--mpt--nowrap__tip": !props.isQuickBetPage && !props.isPopup,
		slip__pick__tip: props.isQuickBetPage,
		"card--qb--nowrap__tip": props.isQuickBetPage && !props.isPopup,
	});

	const oddClasses = classNames(
		"card--qp__odd",
		{
			"card--qp--nowrap__odd": !props.isPopup,
			"card--mpt__odd": !props.isQuickBetPage,
			"card--mpt--nowrap__odd": !props.isQuickBetPage && !props.isPopup,
			"card--qb__odd slip--quick__quote": props.isQuickBetPage,
			"card--qb--nowrap__odd": props.isQuickBetPage && !props.isPopup,
		},
		"quote--tny"
	);

	if (
		offer.sportData.eventType &&
		offer.sportData.eventType !== EventType.NORMAL
	) {
		return <>{offer.formattedBettingTypeTip}</>;
	}

	if (props.isPopup) {
		return (
			<>
				<div
					className={classNames("card--qp__track", {
						"card--mpt__track": !props.isQuickBetPage,
						"card--qb__track": props.isQuickBetPage,
					})}
				/>

				<div className={marketClasses}>
					<span className={typeClasses}>
						{offer.formattedBettingType}
					</span>
					:
					<span className={tipClasses}>
						{offer.formattedBettingTypeTip}
					</span>
				</div>

				{props.withCoefficient && (
					<strong className={oddClasses}>
						{offer.value.toFixed(2)}
					</strong>
				)}
			</>
		);
	}

	return (
		<div className={itemClasses}>
			<div
				className={classNames("card--qp__track", {
					"card--mpt__track": !props.isQuickBetPage,
					"card--qb__track": props.isQuickBetPage,
				})}
			/>
			<div className={marketClasses}>
				<span className={typeClasses}>
					{offer.formattedBettingType}
				</span>
				:
				<span className={tipClasses}>
					{offer.formattedBettingTypeTip}
				</span>
			</div>

			{props.withCoefficient && (
				<strong className={oddClasses}>{offer.value.toFixed(2)}</strong>
			)}
		</div>
	);
}
